export interface KnownPushSubscription {
  endpoint: string;
  subscription: PushSubscription;
}

function isKnownRegistration(registration: ServiceWorkerRegistration): boolean {
  try {
    const path = new URL(registration.scope).pathname;
    return path === '/' || path === '/tasks-app/';
  } catch {
    return false;
  }
}

/** Inspect only the two Valentine registrations the current browser exposes. */
export async function listKnownPushSubscriptions(): Promise<KnownPushSubscription[]> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    throw new Error('Browser cannot resolve Valentine push registrations');
  }
  if (typeof navigator.serviceWorker?.getRegistrations !== 'function') {
    throw new Error('Browser cannot resolve Valentine push registrations');
  }

  const registrations = await navigator.serviceWorker.getRegistrations();

  const subscriptions = await Promise.all(registrations
    .filter(isKnownRegistration)
    .map(async (registration): Promise<KnownPushSubscription | null> => {
      const subscription = await registration.pushManager.getSubscription();
      return subscription ? { endpoint: subscription.endpoint, subscription } : null;
    }));

  const endpoints = new Set<string>();
  return subscriptions.filter((entry): entry is KnownPushSubscription => {
    if (!entry || endpoints.has(entry.endpoint)) return false;
    endpoints.add(entry.endpoint);
    return true;
  });
}
